import { SxProps, Theme } from '@mui/material';
import { TEXT_LIGHT_GRAY } from '../../../styles/GlobalStyles';

const SEARCH_FIELD_BORDER_RADIUS = '4px';

export const searchCoursesStyles = {
  autocomplete: (theme: Theme) =>
    ({
      width: '300px',
      marginLeft: 'auto',
      marginBottom: theme.spacing(1),
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#ffffff',
        borderRadius: SEARCH_FIELD_BORDER_RADIUS,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderRadius: SEARCH_FIELD_BORDER_RADIUS,
      },
    }) as SxProps<Theme>,

  paper: (_theme: Theme) =>
    ({
      backgroundColor: '#ffffff',
    }) as SxProps<Theme>,

  listbox: (_theme: Theme) =>
    ({
      '& .MuiAutocomplete-groupLabel': {
        color: '#bfbfbf',
        fontSize: '12px',
      },
      '& .MuiAutocomplete-option .search-courses-result-name': {
        color: TEXT_LIGHT_GRAY,
        fontSize: '14px',
      },
    }) as SxProps<Theme>,
};

export default searchCoursesStyles;
